import { useCallback, useState } from 'react'
import type { GridApi } from 'ag-grid-community'

export interface GridStats {
  count: number
  kpSum: number
  orderedSum: number
  filtered: boolean
}

/**
 * Счётчик по видимым (после фильтров) строкам AG Grid: количество, сумма КП и
 * сумма «в заказ». Подключается через onModelUpdated → recompute(api). Когда
 * фильтров нет — на странице обычно берётся точный серверный итог, иначе
 * показываются эти значения. Используется и для активных, и для обработанных
 * заявок (одинаковая логика forEachNodeAfterFilter).
 */
export function useGridFilterStats() {
  const [stats, setStats] = useState<GridStats>({
    count: 0,
    kpSum: 0,
    orderedSum: 0,
    filtered: false,
  })
  const recompute = useCallback((api: GridApi) => {
    let count = 0
    let kpSum = 0
    let orderedSum = 0
    api.forEachNodeAfterFilter((node) => {
      if (!node.data) return
      count++
      const d = node.data as { quotationSum?: number | null; orderedSum?: number }
      kpSum += d.quotationSum ?? 0
      orderedSum += d.orderedSum ?? 0
    })
    setStats({ count, kpSum, orderedSum, filtered: api.isAnyFilterPresent() })
  }, [])
  return { stats, recompute }
}
